import { NewselaFullSVG } from "@newsela/angelou";

import AILunaTag from "@/components/AIComponents/AILunaTag/AILunaTag";
import Icon from "@/components/Icon";
import {
  headerCss,
  lessonPlanContainerCss,
  newselaLogoCss,
  titleTextCss,
} from "./LessonPlanPDF.style";

interface LessonPlanPDFProps {
  articleShortTitle: string;
  htmlString: string;
}

const LessonPlanPDF = ({
  articleShortTitle,
  htmlString,
}: LessonPlanPDFProps) => {
  return (
    <div css={lessonPlanContainerCss}>
      <div css={headerCss}>
        <Icon SvgComponent={NewselaFullSVG} style={newselaLogoCss} />
        <h2 css={titleTextCss}>Lesson plan: {articleShortTitle}</h2>
        <AILunaTag textVersion="long" />
      </div>

      {/* NOTE: This HTML can be safely rendered as it always comes from Tiptap's editor.getHTML() */}
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: htmlString }} />
    </div>
  );
};

export default LessonPlanPDF;
